import { Box, Skeleton } from '@chakra-ui/react';
import type React from 'react';

interface NotificationsListSkeletonProps {
  rows?: number;
}

const NotificationsListSkeleton: React.FC<NotificationsListSkeletonProps> = ({ rows = 10 }) => {
  const getRandomWidth = () => {
    const widths = ['60%', '75%', '90%'];
    return widths[Math.floor(Math.random() * widths.length)];
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {Array.from({ length: rows }).map((_, index) => (
        <Box
          key={index}
          p={2.5}
          pr={4}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          bg={{ base: 'gray.50', _dark: 'gray.800' }}
          borderRadius="md"
          gap={2}
          borderLeft="1px solid"
          borderColor={{ base: 'gray.200', _dark: 'gray.700' }}
        >
          <Box display="flex" alignItems="center" flex="1">
            <Box display="flex" alignItems="center" width="45px" height="40px" mr={2}>
              <Skeleton
                width="40px"
                height="40px"
                borderRadius="md"
                variant="shine"
                css={{
                  '--start-color': {
                    base: 'colors.gray.200',
                    _dark: 'colors.gray.700',
                  },
                  '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
                }}
              />
            </Box>
            <Box display="flex" flexDirection="column" gap={1.5} flex="1">
              <Skeleton
                height="12px"
                width={getRandomWidth()}
                variant="shine"
                css={{
                  '--start-color': {
                    base: 'colors.gray.200',
                    _dark: 'colors.gray.700',
                  },
                  '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
                }}
              />
              <Skeleton
                height="10px"
                width="30%"
                variant="shine"
                css={{
                  '--start-color': {
                    base: 'colors.gray.200',
                    _dark: 'colors.gray.700',
                  },
                  '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
                }}
              />
            </Box>
          </Box>
          <Box display="flex" alignItems="center" width="45px" height="35px">
            <Skeleton
              width="35px"
              height="35px"
              borderRadius="md"
              variant="shine"
              css={{
                '--start-color': {
                  base: 'colors.gray.200',
                  _dark: 'colors.gray.700',
                },
                '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default NotificationsListSkeleton;

